TS.ns('WL');

WL.documentPartnerModel = new Class({
    Extends: WL.partnerViewModel,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        //me.watchProperty(me.Document.UniqueID, me._uniqueIDChanged, me);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        if (me.lkpPartnerType_Property != undefined) {
            me.lkpPartnerType_Property.on('selectionChanged', me._partnerTypeChanged, me);
        }

        var incomeSourceList = me.getDomainProperty('dgPartnerIncomeSources_Property');

        if (incomeSourceList != null) {  
            incomeSourceList.on('cellValueChanged', me.onIncomeSourceSelect); 
        }

        var personWorkplaceList = me.getDomainProperty('dgPersonWorkplaceCollection_Property');

        if (personWorkplaceList != null) {
            personWorkplaceList.on('cellValueChanged', me.onWorkplaceChanged);
            personWorkplaceList.on('afterDelete', me.onWorkplaceRemoved);
        }
    },

    //_uniqueIDChanged: function () {
    //    var me = this;

    //    me.performServerCommand({
    //        cmd: 'SearchPartner',
    //        submitModel: true,
    //        blockUI: true
    //    });
    //},

    _partnerTypeChanged: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'Dummy',
            submitModel: true,
            blockUI: true
        }); 
    },

    onIncomeSourceSelect: function (e) {
        var me = this,
            rec = e.item, 
            owner = me._getOwner(),
            incomeSourceList = owner.getDomainProperty('dgPartnerIncomeSources_Property');

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'IsSelected') {
            owner.performServerCommand({
                cmd: 'SelectIncomeSource',
                submitModel: true,
                extraData: {
                    IsSelected: incomeSourceList.SelectedItem().IsSelected(),
                    UID: incomeSourceList.SelectedItem().UID()
                },
                blockUI: true
            });
        }
    },

    onWorkplaceRemoved: function (e) {
        var me = this,
            owner = me._getOwner();

            owner.performServerCommand({
                cmd: 'AddOrDeleteIncomeSources',
                submitModel: true,
                blockUI: true
            });
    },

    onWorkplaceChanged: function (e) {
        var me = this,
            rec = e.item,
            owner = me._getOwner();

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'EmployerId') {
            owner.performServerCommand({
                cmd: 'AddOrDeleteIncomeSources',
                submitModel: true,
                blockUI: true
            });
        }
    }

});